import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import { selectHasNewResultsToView } from "store/reducers/user/UserAccountSlice";
import NextMoveCard from ".";
import Translate from "translate/Translate";

const ReviewResultsNextMoveCard = () => {
  const history = useHistory();
  const hasNewResultsToView = useSelector(selectHasNewResultsToView);

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "results_review",
      ctaLocation: "next_move_card",
      ctaId: "test_result"
    });
    history.push(PATHS.RESULTS_SLIDES);
  }, [history]);

  if (!hasNewResultsToView) {
    return null;
  }

  return (
    <NextMoveCard
      id="review-results-next-move"
      title={<Translate text="Review your results and take action" />}
      body={
        <Translate text="Your results are ready! After reviewing them, work with the Genomic Life navigation team and your doctor to take action based on your results." />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        text: "Review your results",
        url: PATHS.RESULTS_SLIDES
      }}
    />
  );
};

export default ReviewResultsNextMoveCard;
